import { createFileRoute } from "@tanstack/react-router";
import type { DetailTab } from "@/features/qc-board/detail-lib";

const DETAIL_TABS: readonly DetailTab[] = ["overview", "reviews", "incidents", "qc", "work", "history"];

// Mở sẵn ngăn một người (link từ Bảng QC, QĐ 0484).
type QcBoardSearch = { staff?: string | undefined; tab?: DetailTab | undefined };

export const Route = createFileRoute("/_app/qc-board/")({
  validateSearch: (search: Record<string, unknown>): QcBoardSearch => ({
    staff: typeof search.staff === "string" ? search.staff : undefined,
    tab: DETAIL_TABS.find((t) => t === search.tab),
  }),
});
